import { render, staticRenderFns } from "./app-loading.vue?vue&type=template&id=80404caa&scoped=true&"
import script from "./app-loading.vue?vue&type=script&lang=js&"
export * from "./app-loading.vue?vue&type=script&lang=js&"
import style0 from "./app-loading.vue?vue&type=style&index=0&id=80404caa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80404caa",
  null
  
)

export default component.exports